export const initVessel = (state, index) => {
    setSelectedVessel(state, index);
    showVessels(state, true);
    if(typeof state.selected.vessel.countries !== 'undefined') {
        state.selected.vessel.nationalites = state.selected.vessel.countries;
    }
  }


export const hideAll = state => {
    state.show['fleets'] = false;
    state.show['vessels'] = false;
    state.show['img'] = false;
};

export const hasFleets = state => state.fleets.length;

export const setSelectFleet = (state, index) => {
    state.selected['fleetIndex'] = index;
    state.selected['fleet'] = state.fleets[index];
    state.show['fleets'] = true;
}

export const fleetHasVessels = state => state.selected['fleet'].vessels.length;


export const setSelectedVessel = (state, index) => {
    state.selected['vesselIndex'] = index;
    state.selected['vessel'] = state.selected['fleet'].vessels[index];

}

export const vesselHasImage = state => state.selected.vessel.images.length;

export const showFleets = (state, val) => state.show.fleets = val;
export const showVessels = (state, val) => state.show.vessels = val;
export const showImg = (state, val) => state.show['img'] = val;


// WEBPACK FOOTER //
// ./vue/fleet/store/modules/helpers.js